import { WhereItem } from "../../globalTypes";
import { isItemList } from "./typeGuards";

export const isWhereItemVoid = (item: WhereItem): boolean => {
  if (isItemList(item)) {
    return item.children.every(isWhereItemVoid);
  }

  return false;
};

export const removeVoidWhereItems = (items: WhereItem[]): WhereItem[] => {
  if (!items) return items; // Just in case I ever pass in null | undefined
  return items.filter((i) => !isWhereItemVoid(i));
};
